import React from "react";
import { NavLink, Link} from "react-router-dom";
import logo from "../assets/img/logo/logo.svg";
import category from "../assets/img/icon/category.svg";
/* eslint-disable */

const Header = ({style}) => {
  return (
    <>
      <header
        id="xb-header-area"
        className="header-area header-style-one is-sticky"
        style={style}
      >
        <div className="xb-header">
          <div className="container">
            <div className="header__wrap ul_li_between">
              <div className="header-logo">
                <Link to="/">
               
                <img src={logo} alt="Om Softwares" />
                </Link>
              </div>
              <div className="main-menu__wrap ul_li navbar navbar-expand-lg">
                <nav className="main-menu collapse navbar-collapse">
                  <ul>
                    <li >
                    <NavLink
                      to="/"
                      className={({ isActive }) =>
                        isActive ? "active" : ""
                      } key="/"
                    >
                        <span className="navlihome">Home</span>
                      </NavLink>
                    </li>
                    
                    <li>
                       <NavLink
                      to="/about" key="/about" className={({ isActive }) =>
                        isActive ? "active" : ""
                      }
                    >
                        <span className="navliabout">About</span>
                      </NavLink>
                    </li>

                    <li >
                    <NavLink
                      to="/blogs"
                      className={({ isActive }) =>
                        isActive ? "active" : ""
                      } key="/blogs"
                    >
                        <span className="navliblogs">Blogs</span>
                      </NavLink>
                    </li>

                    <li className="menu-item-has-children">
                      <NavLink
                      to="/services" key="/services" className={({ isActive }) =>
                        isActive ? "active" : ""
                      }
                    >
                        <span className="navliServices">Services</span>
                      </NavLink>
                      <ul className="submenu">
                        <li>
                          <Link to="/social-media-management">
                            <span>Social Media Management</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/digital-marketing">
                            <span>Digital Marketing</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/web-development">
                            <span>Web Development</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/visual-branding">
                            <span>Visual Branding</span>
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li>
                       <NavLink
                      to="/contact" key="/contact" className={({ isActive }) =>
                        isActive ? "active" : ""
                      }
                    >
                        <span className="navliContact">Contact</span>
                      </NavLink>
                    </li>
                  </ul>
                </nav>
                <div className="xb-header-wrap">
                  <div className="xb-header-menu">
                    <div className="xb-header-menu-scroll">
                      <div className="xb-menu-close xb-hide-xl xb-close"></div>
                      <div className="xb-logo-mobile xb-hide-xl">
                        <Link to="/" rel="home">
                          <img src={logo} alt="Om Softwares Logo" />
                        </Link>
                      </div>
                    
                      <nav className="xb-header-nav">
                        <ul className="xb-menu-primary clearfix">
                          <li className="active menu-item">
                            <Link to="/">
                              <span className="navlihome">Home</span>
                            </Link>
                          </li>
                          <li className="menu-item">
                            <Link to="/about">
                              <span className="navliabout">About</span>
                            </Link>
                          </li>
                          <li className="menu-item">
                            <Link to="/blogs">
                              <span className="navliblogs">Blogs</span>
                            </Link>
                          </li>
                          <li className="menu-item menu-item-has-children">
                              <Link to="/services">
                                <span className="navliServices">Services</span>
                              </Link>
                              <ul className="sub-menu">
                                <li>
                                  <Link to="/social-media-management">
                                    <span>Social Media Management</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/digital-marketing">
                                    <span>Digital Marketing</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/web-development">
                                    <span>Web Development</span>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/visual-branding">
                                    <span>Visual Branding</span>
                                  </Link>
                                </li>
                              </ul>
                            </li>

                          <li className="menu-item">
                            <Link to="/contact">
                              <span className="navliContact">Contact</span>
                            </Link>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                  <div className="xb-header-menu-backdrop"></div>
                </div>
              </div>
              <div className="side-menu d-none d-lg-block">
               
                <a className="burger-menu"
                onClick={(e) => e.preventDefault()}>
                  <img src={category} alt="Menu" />
                </a>
              </div>
              <div className="header-bar-mobile side-menu d-lg-none">
                <a
                  className="xb-nav-mobile"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={category} alt="Menu" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
/* eslint-enable */